module.exports = __webpack_public_path__ + "static/media/riskTwoPoints.b138474c.mp3";